import React, { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconProp, RotateProp } from '@fortawesome/fontawesome-svg-core'

type IconBoxProps = {
    icon: IconProp
    rotate?: RotateProp
    children?: ReactNode
    disabled?: boolean
}

const IconBox: React.FC<IconBoxProps> = ({ icon, rotate, children, disabled = false }) => {
    return (
        <div className={`flex-1 px-4 relative mb-4 shadow-custom-box text-center text-xs h-full max-tablet:px-2.5 ${disabled ? 'bg-gray-100' : 'bg-white'}`}>
            <FontAwesomeIcon
                icon={icon as any}
                className={`absolute ${rotate ? '-ml-4' : 'left-2/4 -translate-x-2/4'} text-custom_yellow -top-4`}
                size="3x"
                rotation={rotate}
            />
            {children}
        </div>
    )
}

export default IconBox
